module.exports = __webpack_public_path__ + "media/img/corporate/logos/adidas-b9ff85accbe0e43f45fa004508a03572.svg";